import { ReactNode } from 'react';

import { Label } from '@/components/ui/label';

export function ReadOnlyField({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="flex flex-col gap-1">
      <Label>{label}</Label>
      <div className="bg-grey-1 ring-grey-3 flex min-h-[41px] flex-wrap items-center gap-1 rounded p-2 ring-2 ring-inset">{children}</div>
    </div>
  );
}
